import React from 'react';
import { Navigate} from 'react-router-dom';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import queryString from 'query-string';
//import Select from 'react-select';
//import AsyncSelect from 'react-select/async';
import Autosuggest from  'react-autosuggest';
import DateTimeCustom from '../_components/react-datetime-custom';
import AccountDropdown from '../_components/AccountDropdown';
import BookingFormStepper from 'Components/BookingFormStepper';
import { userService, frequentAddressService } from '../_services';
import { withRouter } from 'Components/withRouter';
import config from 'config';
import styles from './BookingForm.module.css';

class BookingForm extends React.Component {
    
    /* Autosuggest functions -- start --*/
    getSuggestionsFromList = (value, list) => {
        const inputValue = value.trim().toUpperCase();
        const inputLength = inputValue.length;
        return inputLength === 0 ? [] : list.filter(ref => ref.toUpperCase().indexOf(inputValue) !== -1).slice(0,10);
    }
    getSuggestionValue = suggestion => {
        console.log('getSuggestionValue');
        return suggestion;
    }
    renderSuggestionPlain = suggestion => (
        <div>{suggestion}</div>
    );
    onSuggestionsClearRequested = (keyInState) => {
        console.log('onSuggestionsClearRequested');
        this.setState({
            [keyInState]: []
        });
    };
    onSuggestionSelected = (name, event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        console.log('onSuggestionSelected');
        if(method=='click')
            this.setState({
                [name]: suggestion
            });
    }

    onSuggestionsFetchRequestedReferences = (list, { value, reason }) => {
        var suggestions = this.getSuggestionsFromList(value, list)
        this.setState({
            referenceSuggestions: suggestions
        });
    };
    onSuggestionsFetchRequestedSuburbs = (list, { value, reason }) => {
        var suggestions = this.getSuggestionsFromList(value, list)
        this.setState({
            suburbSuggestions: suggestions
        });
    };

    getSuggestedAddress = suggestion => {
        console.log('getSuggestedAddress');
        return suggestion.full_address;
    }
    shouldRenderSuggestions = (value) => {
        return value && value.trim().length > 0; // override default component which didn't check for value=undefined
    }
    renderSuggestionAddress = suggestion => {
        console.log('renderSuggestionAddress');
        return <div>{suggestion.full_address}</div>
    };
    onSuggestionsFetchAddress = (prefix, { value, reason }) => {
        console.log('onSuggestionsFetchAddress');
        userService.getAddresses(this.state.account, value)
        .then(addresses => {
            this.setState({
                [prefix + 'AddressSuggestions']: addresses
            });
        })
        .catch(error => {
            this.setState({
                [prefix + 'AddressSuggestions']: []
            });
        });
    };
    onAddressSelected = (prefix, event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        console.log('onAddressSelected');
        userService.getAddress(suggestion.id)
        .then(address => {
            console.log('getAddress');
            this.setState({
                [prefix+"company"]: address.company,
                [prefix+"address1"]: address.address1,
                [prefix+"address2"]: address.address2,
                [prefix+"suburb"]: address.suburb,
                [prefix+"contact"]: address.contact,
                [prefix+"phone"]: address.phone,
                [prefix+"instructions"]: address.instructions,
            });
        });
    }
    /* Autosuggest functions -- end -- */
    
    __setState(changes) {
        if(Object.keys(changes).some(r =>
            ["account","is_ready","pickup_date","pickup_time","pickup_company","pickup_address1","pickup_suburb",
            "delivery_company","delivery_address1","delivery_suburb","vehicle_type","is_return","quantity","weight", "ref1"]
            .indexOf(r) >= 0)) {
                changes["submission"] = { state: "" },
                changes["service"] = "",
                changes["services"] =  { state: "empty", options: [] }; // clear it if any rating parameter changed
        }
        this.setState(changes);
    }
    
    swapAddresses(e) {
        e.preventDefault();
        this.__setState({
            pickup_contact: this.state.delivery_contact,
            pickup_phone: this.state.delivery_phone,
            pickup_company: this.state.delivery_company,
            pickup_address1: this.state.delivery_address1,
            pickup_address2: this.state.delivery_address2,
            pickup_suburb: this.state.delivery_suburb,
            pickup_instructions: this.state.delivery_instructions,
            pickup_save: this.state.delivery_save,
            delivery_contact: this.state.pickup_contact,
            delivery_phone: this.state.pickup_phone,
            delivery_company: this.state.pickup_company,
            delivery_address1: this.state.pickup_address1,
            delivery_address2: this.state.pickup_address2,
            delivery_suburb: this.state.pickup_suburb,
            delivery_instructions: this.state.pickup_instructions,
            delivery_save: this.state.pickup_save
        });
    }

    clearPickupAddress(e) {
        e.preventDefault();
        this.__setState({
            pickup_contact: "",
            pickup_phone: "",
            pickup_company: "",
            pickup_address1: "",
            pickup_address2: "",
            pickup_suburb: "",
            pickup_instructions: ""
        });
    }

    clearDeliveryAddress(e) {
        e.preventDefault();
        this.__setState({
            delivery_contact: "",
            delivery_phone: "",
            delivery_company: "",
            delivery_address1: "",
            delivery_address2: "",
            delivery_suburb: "",
            delivery_instructions: ""
        });
    }
    getServices(event) {
        event.preventDefault();
        this.setState({
            services: {state:"loading", options:[]}
        });

        var jobdata = {
          account: this.state.account,
          ready_date: (this.state.is_ready ? "" : this.state.pickup_date.format("YYYY-MM-DD")),
          ready_time: (this.state.is_ready ? "NOW" : this.state.pickup_time.format("HH:mm")),
          pickup_company: this.state.pickup_company,
          pickup_address1: this.state.pickup_address1,
          pickup_suburb: this.state.pickup_suburb,
          delivery_company: this.state.delivery_company,
          delivery_address1: this.state.delivery_address1,
          delivery_suburb: this.state.delivery_suburb,
          vehicle_type: this.state.vehicle_type,
          is_return: this.state.is_return,
          pieces: this.state.quantity,
          weight: this.state.weight,
          ref1: this.state.ref1,
          ref2: this.state.ref2
        };
        
        userService.getServices(jobdata)
        .then(services => {
            var formatter = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' });
            services = services.map(service => ({ value:service.service_code, label:service.description + ' - ' + formatter.format(service.price) }));
            this.setState({
                services: { state:"ready", options:services }
            });

            var selectedService =
                (_.some(this.state.services.options, ['value', this.state.account_default_service]) && this.state.account_default_service) ||
                (_.some(this.state.services.options, ['value', config.defaultService]) && config.defaultService) ||
                "";
            
            console.log('selectedService: ' + selectedService);
            this.setState({
                service: selectedService
            });
        })
        .catch(error => {
            this.setState({
                services: { state:"error", errors: error ? error.split(/\r\n/) : [] }
            });
        });
    }
    
    validateJobData(jobData) {
        if (!jobData.pickup_contact) {
            alert('Pickup contact is mandatory');
            return false;
        }

        if (!jobData.item_type) {
            alert('Item type is mandatory')
            return false;
        }

        return true;
    }

    submitJob(event) {
        event.preventDefault();
        this.setState({
            submission: { state:"submitting" }
        });
        const _ = this.state;
        var jobdata = {
          account: _.account,
          caller_name: _.booked_by,
          ready_date: (_.is_ready ? "" : _.pickup_date.format("YYYY-MM-DD")),
          ready_time: (_.is_ready ? "" : _.pickup_time.format("HH:mm")),
          pickup_contact: _.pickup_contact,
          pickup_phone: _.pickup_phone,
          pickup_company: _.pickup_company,
          pickup_address1: _.pickup_address1,
          pickup_address2: _.pickup_address2,
          pickup_suburb: _.pickup_suburb,
          pickup_instructions: _.pickup_instructions,
          delivery_contact: _.delivery_contact,
          delivery_phone: _.delivery_phone,
          delivery_company: _.delivery_company,
          delivery_address1: _.delivery_address1,
          delivery_address2: _.delivery_address2,
          delivery_suburb: _.delivery_suburb,
          delivery_instructions: _.delivery_instructions,
          is_return: _.is_return,
          service_code: _.service,
          pieces: _.quantity,
          weight: _.weight,
          reference1: _.ref1,
          reference2: _.ref2,
          item_type: _.item_type,
          dangerous_goods: _.dangerous_goods,
          vehicle_type: _.vehicle_type,
          delivery_notification: _.delivery_email,
          delivery_tracking: _.delivery_tracking
        };
        
        var self=this;

        if (!this.validateJobData(jobdata)) {
            
            this.setState({
                submission: { state:"" }
            });

            return false;
        }

        userService.submitJob(jobdata)
        .then(job => {
            this.setState({
                redirect: "/job?id=" + job.job_id
            });
        })
        .catch(error => {
            this.setState({
                submission: { state:"error", errors: error ? error.split(/\r\n/) : [] }
            });
        });
    }    

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.__setState({
            [name]: value
        });
    }
    handleSuggestChange(event, {method,newValue}) {
        const target = event.target;
        const name = target.name;

        this.__setState({
            [name]: newValue
        });
    }
    handleSelectChange(selectName, value) {
        this.__setState({
            [selectName]: value
        });
    }
    handleDatetimeChange(moment,name) {
        this.__setState({[name]: moment});
    }
    handleAccountChange(event) {
        var account = event.target.value;
        userService.getAccountDetails(account).then(details => {
            //details.references
            var changes = {
                account: account,
                ref1_label: details.ref1_label,
                ref2_label: details.ref2_label,
                ref1_required: details.ref1_required,
                ref2_required: details.ref2_required,
                ref1_validate: details.ref1_validate,
                references: (details.references || []).map(x => x.toUpperCase()),
                account_default_service: details.default_service
            };
            var default_address = details.default_address;
            if(default_address && default_address.company /*&& window.confirm("")*/) {
                changes["pickup_contact"] = default_address.contact || "";
                changes["pickup_phone"] = default_address.phone || "";
                changes["pickup_company"] = default_address.company || "";
                changes["pickup_address1"] = default_address.address1 || "";
                changes["pickup_address2"] = default_address.address2 || "";
                changes["pickup_suburb"] = default_address.suburb || "";
                changes["pickup_instructions"] = default_address.instructions || "";
            }
            this.__setState( changes );
        });
    }
    
    /*handleInputChange = (newValue: string) => {
        const inputValue = newValue.replace(/\W/g, '');
        this.setState({ inputValue });
        return inputValue;
    };*/
    
    constructor(props) {
        super(props);
        this.__setState = this.__setState.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSuggestChange = this.handleSuggestChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.swapAddresses = this.swapAddresses.bind(this);
        this.clearPickupAddress = this.clearPickupAddress.bind(this);
        this.clearDeliveryAddress = this.clearDeliveryAddress.bind(this);
        this.savePickupAddress = this.savePickupAddress.bind(this);
        this.saveDeliveryAddress = this.saveDeliveryAddress.bind(this);
        //this.getSuburbs = this.getSuburbs.bind(this);
        this.getServices = this.getServices.bind(this);
        this.validateJobData = this.validateJobData.bind(this);
        this.submitJob = this.submitJob.bind(this);

        this.state = {
            // control/extra
            motd: {},
            //locations: [],
            itemTypes: "",
            vehicleTypes: "",
            ref1_label: "Reference 1",
            ref1_required: "Y",
            ref1_validate: false,
            ref2_label: "Ref 2",
            ref2_required: "N",
            references: [],
            referenceSuggestions: [],
            suburbs: [],
            suburbSuggestions: [],
            pickupAddressSuggestions: [],
            deliveryAddressSuggestions: [],
            services: { state: "initial", options:[] },
            submission: { state: "" },
            redirect: false,
            // form values
            booked_by: "",
            account: "",
            ref1: "",
            ref2: "",
            pickup_contact: "",
            pickup_phone: "",
            pickup_company: "",
            pickup_address1: "",
            pickup_address2: "",
            pickup_suburb: "",
            pickup_instructions: "",
            pickup_save: false,
            is_return: false,
            delivery_contact: "",
            delivery_phone: "",
            delivery_company: "",
            delivery_address1: "",
            delivery_address2: "",
            delivery_suburb: "",
            delivery_instructions: "",
            delivery_save: false,
            item_type: "",
            quantity: 1,
            weight: 1,
            vehicle_type: "1", // any vehicle
            dangerous_goods: false,
            is_ready: true,
            pickup_date: moment(),
            pickup_time: moment(),
            delivery_email: "",
            service: "",
            account_default_service: null,
            delivery_tracking: ""
        };

        var queryParams = queryString.parse(props.router.location.search);
        
        if(queryParams.rebook) {
            var rebookJob = JSON.parse(localStorage.getItem('Job.' + queryParams.rebook));
            if(rebookJob) {

                rebookJob.pickup_instructions = rebookJob.pickup_instructions_without_contact;
                delete rebookJob.pickup_instructions_without_contact;
                rebookJob.delivery_instructions = rebookJob.delivery_instructions_without_contact;
                delete rebookJob.delivery_instructions_without_contact;

                // hydrate from job state to this.state
                Object.keys(rebookJob).forEach(key => {
                    if(!['pickup_date','pickup_time'].includes(key) && this.state.hasOwnProperty(key))
                        this.state[key] = rebookJob[key];
                });

                
                console.log("rehydrated");
            }
        }
    }

    savePickupAddress(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('form-booking'));

        var address = {
            dtrcde: formData.get("account"),
            company: formData.get("pickup_company"),
            addr1: formData.get("pickup_address1"),
            addr2: formData.get("pickup_address2"),
            suburb: formData.get("pickup_suburb"),
            contact: formData.get("pickup_contact"),
            phone: formData.get("pickup_phone"),
            key: formData.get("pickup_key") || ""
        };

        frequentAddressService.addOrUpdateAddress(address)
            .then(response => {
                if (response.status === 200) {
                    if (response.message && response.message !== "") {
                        alert(response.message);
                    }
                    else {
                        alert("Saved");
                    }
                }
                
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
    }
    
    saveDeliveryAddress(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('form-booking'));

        var address = {
            dtrcde: formData.get("account"),
            company: formData.get("delivery_company"),
            addr1: formData.get("delivery_address1"),
            addr2: formData.get("delivery_address2"),
            suburb: formData.get("delivery_suburb"),
            contact: formData.get("delivery_contact"),
            phone: formData.get("delivery_phone"),
            key: formData.get("delivery_key") || ""
        };

        frequentAddressService.addOrUpdateAddress(address)
            .then(response => {
                if (response.status === 200) {
                    if (response.message && response.message !== "") {
                        alert(response.message);
                    }
                    else {
                        alert("Saved");
                    }
                }

            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
    }

    componentDidMount() {
        this.setState({ 
            motd: { loadingMotd: true }
        });
        userService.getMotd().then(motd => this.setState({ motd }));
        userService.getItemTypes().then(itemTypes => {
            var selection = _.concat(
                [{
                    value: "",
                    label: ""
                }],
                itemTypes
                );
            itemTypes = selection.map(item => <option key={item.value}>{item.label}</option>);
            this.setState({ itemTypes });
        });
        userService.getVehicleTypes().then(vehicleTypes => {
            vehicleTypes = vehicleTypes.map(item => <option key={item.value} value={item.value}>{item.label}</option>);
            this.setState({ vehicleTypes });
        });
        userService.getLocations().then(suburbs => {
            //suburbs = suburbs.map(item => <option key={item} value={item}>{item}</option>);
            this.setState({ suburbs });
        });

        if(!this.state.account) {

            if (this.props.authenticatedUser) {

                var user = this.props.authenticatedUser;

                this.setState({
                    booked_by: user.name
                });

                var fakeEvent = { target: { value: user.default_account } };
                this.handleAccountChange(fakeEvent);
            }
        }
        
        $(document).on("keydown", ":input:not(textarea):not(:submit)", function(event) {
            if (event.key == "Enter") {
                event.preventDefault();
            }
        });
    }

    render() {
        if(this.state.redirect) {
            return <Navigate push to={this.state.redirect}/>;
        }
        const { motd } = this.state;

        var canModifyAddresses = this.props.authenticatedUser &&
            this.props.authenticatedUser.privileges &&
            _.some(this.props.authenticatedUser.privileges, ['description', 'Can Modify Addresses']);

        return (
                <div>
                    <div className="container-fluid padding-lr55">
                        <div className="row">
                            <div className="col-xs-12">
                                <BookingFormStepper
                                    account={this.state.account}
                                    booked_by={this.state.booked_by}
                                    ref1_required={this.state.ref1_required}
                                    ref1={this.state.ref1}
                                    ref2_required={this.state.ref2_required}
                                    ref2={this.state.ref2}
                                    pickup_contact={this.state.pickup_contact}
                                    pickup_phone={this.state.pickup_phone}
                                    pickup_company={this.state.pickup_company}
                                    pickup_address1={this.state.pickup_address1}
                                    pickup_address2={this.state.pickup_address2}
                                    pickup_suburb={this.state.pickup_suburb}
                                    delivery_contact={this.state.delivery_contact}
                                    delivery_phone={this.state.delivery_phone}
                                    delivery_company={this.state.delivery_company}
                                    delivery_address1={this.state.delivery_address1}
                                    delivery_address2={this.state.delivery_address2}
                                    delivery_suburb={this.state.delivery_suburb}
                                    vehicle_type={this.state.vehicle_type}
                                    item_type={this.state.item_type}
                                    quantity={this.state.quantity}
                                    weight={this.state.weight}
                                    is_ready={this.state.is_ready}
                                    pickup_date={this.state.pickup_date}
                                    pickup_time={this.state.pickup_time}
                                    service={this.state.service}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid padding-lr55 bg-form">
                    
                        <form className="flat" id="form-booking" method="POST" action="/fake">
                            <div className="row">
                                <div className="col-sm-4 col-lg-3">
                                    <div className="row h3">
                                        <div className="col-xs-12">Account</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="booked_by">*Booked By</label>
                                                <input className="form-control" type="text" name="booked_by" value={this.state.booked_by} onChange={this.handleChange}/>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="account">*Account</label>
                                                <AccountDropdown className="form-control"
                                                    authenticatedUser={this.props.authenticatedUser}
                                                    name="account"
                                                    value={this.state.account}
                                                    onChange={this.handleAccountChange} />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="row h3">
                                        <div className="col-xs-12">References</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className={"form-group " + (this.state.ref1_required == "H" ? " hide" : "")}>
                                                <label htmlFor="ref1">{(this.state.ref1_required == "Y" ? "* " : "") + this.state.ref1_label}</label>
                                                <Autosuggest
                                                    suggestions={this.state.referenceSuggestions}
                                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedReferences.bind(this, this.state.references)}
                                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this, "referenceSuggestions")}
                                                    onSuggestionSelected={this.onSuggestionSelected.bind(this,'ref1')}
                                                    getSuggestionValue={this.getSuggestionValue}
                                                    renderSuggestion={this.renderSuggestionPlain}
                                                    inputProps={{
                                                        className:"form-control",
                                                        type:"text",
                                                        name:"ref1",
                                                        value:this.state.ref1,
                                                        onChange: this.handleSuggestChange }}
                                                    />
                                            </div>
                                            <div className={"form-group " + (this.state.ref2_required == "H" ? " hide" : "")}>
                                                <label htmlFor="ref2">{(this.state.ref2_required == "Y" ? "* " : "") + this.state.ref2_label}</label>
                                                <input className="form-control" type="text" name="ref2" value={this.state.ref2} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row h3">
                                        <div className="col-xs-12">Notices</div>
                                    </div>
                                    <div className="row">
                                        {motd.loadingMotd && <em>Loading message...</em>}
                                        {motd.message &&
                                        <div className="col-xs-12 notices" dangerouslySetInnerHTML={{__html: motd.message.replace(/\n/g,"<br>")}} />
                                        }
                                    </div>
                                    
                                </div>
                              
                                <div className="col-sm-8 col-lg-6">
                                    <div className="container-fluid padding-lr0">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="row h3">
                                                    <div className="col-xs-12">Pickup
                                                        <button className="btn btn-dl-green pull-right" styleName="styles.swap-button" id="swap" onClick={this.swapAddresses}>SWAP</button>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-12">
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_contact">*Contact</label>
                                                            <input className="form-control" type="text" id="pickup_contact" name="pickup_contact" value={this.state.pickup_contact} onChange={this.handleChange} required/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_phone">Phone</label>
                                                            <input className="form-control" type="text" id="pickup_phone" name="pickup_phone" value={this.state.pickup_phone} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_company">*Company</label>
                                                            <Autosuggest
                                                                suggestions={this.state.pickupAddressSuggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchAddress.bind(this, 'pickup')}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this, "pickupAddressSuggestions")}
                                                                onSuggestionSelected={this.onAddressSelected.bind(this,'pickup_')}
                                                                getSuggestionValue={this.getSuggestedAddress}
                                                                renderSuggestion={this.renderSuggestionAddress}
                                                                inputProps={{
                                                                    className:"form-control",
                                                                    type:"text",
                                                                    name:"pickup_company",
                                                                    value:this.state.pickup_company,
                                                                    onChange: this.handleSuggestChange }}
                                                                />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_address1">*Address</label>
                                                            <input className="form-control" type="text" id="pickup_address1" name="pickup_address1" value={this.state.pickup_address1} onChange={this.handleChange}/>
                                                            <input className="form-control" type="text" id="pickup_address2" name="pickup_address2" value={this.state.pickup_address2} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_suburb">*Suburb</label>
                                                            <Autosuggest
                                                                suggestions={this.state.suburbSuggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedSuburbs.bind(this, this.state.suburbs)}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this, "suburbSuggestions")}
                                                                onSuggestionSelected={this.onSuggestionSelected.bind(this,'pickup_suburb')}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestionPlain}
                                                                inputProps={{
                                                                    className:"form-control",
                                                                    type:"text",
                                                                    name:"pickup_suburb",
                                                                    value:this.state.pickup_suburb,
                                                                    onChange: this.handleSuggestChange }}
                                                                />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="pickup_instructions">Instructions</label>
                                                            <textarea className="form-control" rows="3" id="pickup_instructions" name="pickup_instructions" value={this.state.pickup_instructions} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group lh33">
                                                            {
                                                                canModifyAddresses &&
                                                                <div className="pull-left">
                                                                    <button className="btn btn-dl-green" styleName="styles.address-save-clear-button" onClick={this.savePickupAddress}>SAVE</button>
                                                                </div>
                                                            }
                                                            <div className="pull-right">
                                                                <button className="btn btn-dl-green pull-right" styleName="styles.address-save-clear-button" onClick={this.clearPickupAddress}>CLEAR</button>
                                                            </div>                        
                                                        </div>                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="row h3">
                                                    <div className="col-xs-12">Delivery
                                                        <div className="pull-right">
                                                            <input type="checkbox" className="pseudo-checkbox sr-only" id="is_return" name="is_return" checked={this.state.is_return} onChange={this.handleChange}/>
                                                            <label htmlFor="is_return" className="padding-lr10">Return</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-12">
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_contact">Contact</label>
                                                            <input className="form-control" type="text" id="delivery_contact" name="delivery_contact" value={this.state.delivery_contact} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_phone">Phone</label>
                                                            <input className="form-control" type="text" id="delivery_phone" name="delivery_phone" value={this.state.delivery_phone} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_company">*Company</label>
                                                            <Autosuggest
                                                                suggestions={this.state.deliveryAddressSuggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchAddress.bind(this, 'delivery')}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this, "deliveryAddressSuggestions")}
                                                                onSuggestionSelected={this.onAddressSelected.bind(this,'delivery_')}
                                                                getSuggestionValue={this.getSuggestedAddress}
                                                                renderSuggestion={this.renderSuggestionAddress}
                                                                shouldRenderSuggestions={this.shouldRenderSuggestions}
                                                                inputProps={{
                                                                    className:"form-control",
                                                                    type:"text",
                                                                    name:"delivery_company",
                                                                    value:this.state.delivery_company,
                                                                    onChange: this.handleSuggestChange }}
                                                                />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_address1">*Address</label>
                                                            <input className="form-control" type="text" id="delivery_address1" name="delivery_address1" value={this.state.delivery_address1} onChange={this.handleChange}/>
                                                            <input className="form-control" type="text" id="delivery_address2" name="delivery_address2" value={this.state.delivery_address2} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_suburb">*Suburb</label>
                                                            <Autosuggest
                                                                suggestions={this.state.suburbSuggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedSuburbs.bind(this, this.state.suburbs)}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this, "suburbSuggestions")}
                                                                onSuggestionSelected={this.onSuggestionSelected.bind(this,'delivery_suburb')}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestionPlain}
                                                                inputProps={{
                                                                    className:"form-control",
                                                                    type:"text",
                                                                    name:"delivery_suburb",
                                                                    value:this.state.delivery_suburb,
                                                                    onChange: this.handleSuggestChange }}
                                                                />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="delivery_instructions">Instructions</label>
                                                            <textarea className="form-control" rows="3" id="delivery_instructions" name="delivery_instructions" value={this.state.delivery_instructions} onChange={this.handleChange}/>
                                                        </div>
                                                        <div className="form-group lh33">
                                                            {
                                                                canModifyAddresses &&
                                                                <div className="pull-left">
                                                                    <button className="btn btn-dl-green" styleName="styles.address-save-clear-button" onClick={this.saveDeliveryAddress}>SAVE</button>
                                                                </div>
                                                            }
                                                            <div className="pull-right">
                                                                <button className="btn btn-dl-green pull-right" styleName="styles.address-save-clear-button" onClick={this.clearDeliveryAddress}>CLEAR</button>
                                                            </div>
                                                        </div>                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="row h3">
                                                    <div className="col-xs-12">Goods</div>
                                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                                                        <div className="form-group">
                                                            <label htmlFor="item_type">*Item Type</label>
                                                            <select className="form-control" id="item_type" name="item_type" value={this.state.item_type} onChange={this.handleChange}>
                                                                {this.state.itemTypes}
                                                            </select>
                                                        </div>                                    
                                                    </div>                                    
                                                    <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2">
                                                        <div className="form-group">
                                                            <label htmlFor="quantity">*Quantity</label>
                                                            <input className="form-control" type="text" id="quantity" name="quantity" value={this.state.quantity} onChange={this.handleChange}/>
                                                        </div>                                    
                                                    </div>
                                                    <div className="col-xs-6 col-sm-3 col-md-3 col-lg-2">
                                                        <div className="form-group">
                                                            <label htmlFor="quantity">*Weight</label>
                                                            <input className="form-control" type="text" id="weight" name="weight" value={this.state.weight} onChange={this.handleChange}/>
                                                        </div>                                    
                                                    </div>
                                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                                        <div className="form-group">
                                                            <label htmlFor="vehicle_type">Vehicle type suitable for pickup</label>
                                                            <select className="form-control" id="vehicle_type" name="vehicle_type" value={this.state.vehicle_type} onChange={this.handleChange}>
                                                                {this.state.vehicleTypes}
                                                            </select>
                                                        </div>                                    
                                                    </div>
                                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                                                        <div className="padding-t40"></div>
                                                        <div>
                                                            <input type="checkbox" className="pseudo-checkbox sr-only" id="dangerous_goods" name="dangerous_goods" checked={this.state.dangerous_goods} onChange={this.handleChange}/>
                                                            <label htmlFor="dangerous_goods">Dangerous Goods</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <div className="row h3">
                                        <div className="col-xs-12">
                                            <span className="pull-left">Time</span>
                                            <div className="pull-left padding-lr10" styleName="material-switch">
                                                <input type="checkbox" id="is_ready" name="is_ready" checked={this.state.is_ready} onChange={this.handleChange} />
                                                <label htmlFor="is_ready"></label>
                                            </div>
                                            <label className="">{this.state.is_ready ? "Job is ready for immediate pickup" : "Job will be ready for pickup"}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 gijgo-ui-hack">
                                            <div className="form-group">
                                                <label htmlFor="pickup_date">*Date</label>
                                                {<DateTimeCustom id="pickup_date" name="pickup_date" inputProps={{name:"pickup_date",disabled:this.state.is_ready}}
                                                    dateFormat="D/M/YYYY" timeFormat={false} closeOnSelect={true} spanClass="glyphicon-calendar"
                                                    value={this.state.pickup_date || moment(new Date())}
                                                    onChange={moment => this.handleDatetimeChange(moment, 'pickup_date')}/>}
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pickup_time">*Time</label>
                                                {<DateTimeCustom id="pickup_time" name="pickup_time" inputProps={{name:"pickup_time",disabled:this.state.is_ready}}
                                                    dateFormat={false} timeFormat={"HH:mm"} closeOnSelect={true} spanClass="glyphicon-time"
                                                    value={this.state.pickup_time || moment()}
                                                    onChange={moment => this.handleDatetimeChange(moment, 'pickup_time')}/>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <div className="row h3">
                                        <div className="col-xs-12">Delivery Tracking</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="delivery_tracking">Email</label>
                                                <input className="form-control" type="text" id="delivery_tracking" name="delivery_tracking" value={this.state.delivery_tracking} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-6 col-sm-4 col-lg-3">
                                    <div className="row h3">
                                        <div className="col-xs-12">Delivery Confirmation</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="delivery_email">Email/Txt Number</label>
                                                <input className="form-control" type="text" id="delivery_email" name="delivery_email" value={this.state.delivery_email} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-4 col-lg-3">
                                    {this.state.services.state !== "ready" &&
                                    <div>
                                        <div className="row h3">
                                            <div className="col-xs-12">Services</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <label className="text-muted">Click the show services button to see services available for the addresses selected above</label>
                                                <button className="btn btn-dl-green pull-left" onClick={this.getServices}>SHOW SERVICES</button>
                                                {this.state.services.state == "loading" &&
                                                    <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10 text250"/>
                                                }
                                                {this.state.services.state == "error" &&
                                                    <ul className="service-errors">
                                                        {this.state.services.errors.map((item,index) => (
                                                        <li key={item+index}>{item}</li>
                                                        ))}
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    {this.state.services.state == "ready" &&
                                    <div>
                                        <div className="row h3">
                                            <div className="col-xs-12">Services</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 service-options">
                                                <div className="form-group">
                                                    <label className="text-muted">Note: Pricing excludes fuel surcharge, information on fuel surcharges can be found <a target="dlvfr" href="https://www.deadlineexpress.co.nz/forms-resources/#fuel-surcharge">here</a>
                                                    </label>
                                                </div>
                                                {this.state.services.options.map((item,index) => (
                                                    <div className="md-radio md-radio-right md-radio-justify" key={"DIV" + item.value}>
                                                        <input
                                                            type="radio"
                                                            key={"RADIO" + item.value}
                                                            id={"service"+index}
                                                            name="service"
                                                            value={item.value}
                                                            onChange={this.handleChange}
                                                            checked={this.state.service === item.value}
                                                            />
                                                        <label key={"LABEL" + item.value} htmlFor={"service"+index}>{item.label}</label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 padding-tb40">
                                                <button className="btn btn-dl-green pull-right" onClick={this.submitJob} disabled={this.state.submission.state == "submitting"}>SUBMIT JOB</button>
                                                {this.state.submission.state == "submitting" &&
                                                    <span className="glyphicon glyphicon-refresh glyphicon-spin padding-lr10 pull-right" style={{fontSize:"250%"}} />
                                                }
                                                {this.state.submission.state == "error" &&
                                                    <ul className="service-errors">
                                                        {this.state.submission.errors.map((item,index) => (
                                                        <li key={item+index}>{item}</li>
                                                        ))}
                                                    </ul>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </form>
                
                    </div>
                </div>
        )
    }
}

export default withRouter(BookingForm);